import React, { useState } from "react";
import "../styles/landing.css";
import {
  FlashlightProvider,
  FlashlightSection,
} from "../components/FlashLightElements";
import ilustrations from "../assets/ilustrations.svg";
import ilustrations2 from "../assets/ilustrations2.svg";
import logo from "../assets/fullLogo.svg";
import basicLogo from "../assets/logo.png";
import ServiceCard from "../components/ServiceCard";
import ProjectsSection from "../components/ProjectsSection";
import Marquee from "react-fast-marquee";
import mobileIlustrations from "../assets/mobileIlustrations.svg";

import services from "../information/Services";

const Landing = () => {
  const [clientReviews] = useState([
    {
      stars: 5,
      client: "Ana Pérez",
      text: "Tomás hace el proceso súper fácil y agradable!",
    },
    {
      stars: 5,
      client: "Carlos Rodríguez",
      text: "¡Qué lujo trabajar con Tomás!",
    },
    {
      stars: 5,
      client: "María López",
      text: "Mi equipo de confianza para cualquier duda tecnológica.",
    },
  ]);

  const renderStars = (count) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
    stars.push(
    <span key={i} className={`cr-star ${i < count ? "filled" : ""}`}>
    ★
    </span>
    );
    }
    return stars;
    };

  const MobileLanding = () => {
    return (
      <div>
        <div style={{height: '100vh', backgroundColor: '#0F1138', zIndex: 100}}>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <img src={basicLogo} alt="logo" style={{height: '36px', width: 'auto', paddingTop: 32}} />
          </div>
          <div style={{padding: '20px', marginBottom: 30}}>
            <h3 className="fredoka-400"
                    style={{
                      fontSize: "50px",
                      color: "#7275BB",
                      textAlign: "center",
                    }}>Impulsamos tu negocio con claridad, estrategia y visión digital.</h3>
          </div>
          <div>
            <Marquee gradient={false} speed={50}>
              <span className="fredoka-400" style={{color: "#D8ECEB"}}>INNOVACIÓN&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✷&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;DIGITALIZACIÓN&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✷&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;DESARROLLO&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✷&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;DISEÑO&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✷&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;WEB&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;APP&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✷&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PROGRAMACIÓN&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✷&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FUNCIONALIDAD&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✷&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CLARIDAD&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✷&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CONFIANZA</span>
            </Marquee>
          </div>
        </div>
        <div style={{height: '100vh', backgroundColor: '#FFF6E8', zIndex: 100, position: 'relative'}}>
          <img src={mobileIlustrations} alt="ilustrations2" style={{width: '90vw', height: 'auto', marginLeft: '5%', marginTop: '15%', objectFit: 'cover', position: 'absolute', top: 0, left: 0}} />
          <img src={logo} alt="logo" style={{width: '200px', height: 'auto', marginLeft: '5%', marginTop: '15%', objectFit: 'cover', position: 'absolute', top: 0, left: 0}} />
          <h3 className="fredoka-400" style={{marginLeft: '5%', marginTop: '35%', color: '#0F1138', fontSize: '28px', width: '80%', position: 'absolute', top: '12vh', left: 0}}>
            Nos ponemos en el papel de nuestros clientes
            para entender sus necesidades y ofrecer soluciones que
            faciliten, aceleren y automatizen sus flujos de trabajo.
          </h3>
        </div>
        <div style={{backgroundColor: '#FFF6E8', zIndex: 100, position: 'relative'}}>
          <div style={{padding: '20px'}}>
            <h2
              style={{
                textAlign: "left",
                color: "#C6AEF5",
                fontFamily: "Helvetica Neue",
                fontWeight: "500",
                fontSize: "18px",
              }}
            >
              NUESTROS SERVICIOS
            </h2>
            <div className="services-grid mobile">
              { services.services.filter(service => service.landing).map((service, index) => {
                return(
                  <ServiceCard
                    key={index}
                    title={service.title}
                    alt={service.title}
                    description={service.description}
                    link={`/services/${service.id}`}
                    icon={service.image}
                  />
                )
              })}
            </div>
          </div>
        </div>
        {/* <div className="services-grid-mobile" style={{height: 'auto', backgroundColor: '#FFF6E8', zIndex: 100, position: 'relative'}}>
           <ProjectsSection />
        </div> */}
        <div style={{height: '100vh', backgroundColor: '#E7F58E', zIndex: 100, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
          <h3 className="fredoka-400" style={{color: '#0F1138', fontSize: '34px', width: '80%', textAlign: 'center'}}>¡Nuestro éxito está  en la satisfacción de nuestros clientes!</h3>
          <Marquee gradient={false} speed={70}>
            <div className="cr-list">
              {clientReviews.map((review, index) => (
                <div key={index} className="cr-item">
                  <div className="cr-stars">{renderStars(review.stars)}</div>
                  <blockquote className="cr-text">“{review.text}”</blockquote>
                  <p className="cr-client">{review.client}</p>
                </div>
              ))}
            </div>
          </Marquee>
        </div>
      </div>
    );
  };

  const DesktopLanding = () => {
    return (
      <FlashlightProvider radius={150}>
          <FlashlightSection
            backgroundColor="#FFF6E8"
            curtainColor="#0F1138"
            backgroundChildren={
              <div>
                <img src={ilustrations} alt="ilustrations" />
              </div>
            }
            foregroundChildren={
              <div style={{ maxWidth: "948px" }}>
                <h1
                  className="fredoka-400"
                  style={{
                    fontSize: "80px",
                    color: "#7275BB",
                    textAlign: "center",
                  }}
                >
                  Impulsamos tu negocio con claridad, estrategia y visión digital.
                </h1>
              </div>
            }
          />
          <FlashlightSection
            backgroundColor="#FFF6E8"
            curtainColor="#FFF6E8"
            cursor="auto"
            backgroundChildren={<div></div>}
            foregroundChildren={
              <div
                style={{
                  width: "100%",
                  minHeight: "100vh",
                  backgroundImage: `url(${ilustrations2})`,
                  backgroundSize: "auto",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <div>
                  <img
                    src={logo}
                    alt="logo"
                    style={{ width: "228px", height: "auto" }}
                  />
                  <p
                    className="fredoka-400"
                    style={{
                      width: "626px",
                      fontSize: "32px",
                      color: "#0F1138",
                      textAlign: "left",
                    }}
                  >
                    Nos ponemos en el papel de nuestros clientes
                    para entender sus necesidades y ofrecer soluciones que
                    faciliten, aceleren y automatizen sus flujos de trabajo.
                  </p>
                </div>
              </div>
            }
          />
          <FlashlightSection
            backgroundColor="#FFF6E8"
            curtainColor="#FFF6E8"
            cursor="auto"
            backgroundChildren={<div></div>}
            foregroundChildren={
              <div>
                <h2
                  style={{
                    textAlign: "left",
                    color: "#C6AEF5",
                    fontFamily: "Helvetica Neue",
                    fontWeight: "500",
                    fontSize: "18px",
                  }}
                >
                  NUESTROS SERVICIOS
                </h2>
                <div className="services-grid">
                  { services.services.filter(service => service.landing).map((service, index) => {
                    return(
                      <ServiceCard
                        key={index}
                        title={service.title}
                        description={service.description}
                        link={`/services/${service.id}`}
                        alt={service.title}
                        icon={service.image}
                      />
                    )
                  })}
                </div>
              </div>
            }
          />
          {false && <FlashlightSection
            backgroundColor="#FFF6E8"
            curtainColor="#FFF6E8"
            cursor="auto"
            backgroundChildren={<div></div>}
            foregroundChildren={
              <ProjectsSection />
            }
          />}
          <FlashlightSection
            backgroundColor="#FFF6E8"
            curtainColor="#FFF6E8"
            cursor="auto"
            backgroundChildren={<div></div>}
            foregroundChildren={
              <div>
                <h1
                  style={{
                    textAlign: "center",
                    color: "#7275BB",
                    fontFamily: "Helvetica Neue",
                    fontWeight: "500",
                    fontSize: "52px",
                    maxWidth: "848px",
                    margin: "auto",
                    marginBottom: "8rem",
                  }}
                >
                  ¡Nuestro éxito está en la satisfacción de nuestros clientes!
                </h1>
                <div className="cr-list">
                  {clientReviews.map((review, index) => (
                    <div key={index} className="cr-item">
                      <div className="cr-stars">{renderStars(review.stars)}</div>
                      <blockquote className="cr-text">“{review.text}”</blockquote>
                      <p className="cr-client">{review.client}</p>
                    </div>
                  ))}
                </div>
              </div>
            }
          />
        </FlashlightProvider>
    );
  };

  return (
    <div>
      <div className="mobile-landing">
        <MobileLanding />
      </div>
      <div className="desktop-landing">
        <DesktopLanding />
      </div>
    </div>
  );
};

export default Landing;
